import React from 'react'
import "./../Convenience/ConvenienceStyle.css"
import scene from "./../../Assets/scene.png"

function Convenience() {
  return (
    <div className='footer_main_div'>
      <div className='footer_flex' >
        <div className='footer_content' >

          <div className='convenience_text' >Close At Your Convenience</div>
          <div className='easy_selling' >Selling your home has never been so easy!</div>
          <div className='convenience_btn' type="button">Get My Offer Now!</div>
          <div className='contact_line'>Or Call Us For FREE <span className='numm'>866-928-4635</span></div>





        </div>

      </div>

    </div>
  )
}

export default Convenience
